import {
  Button,
  Color,
  Flex,
  FlexAlign,
  FlexDirection,
  FlexItem,
  FlexSpacer,
  ListTile,
  Margin,
  Size,
  Spinner,
  Text,
  Tier,
  Title,
} from '@drawbotics/react-drylus';
import { css } from '@emotion/css';
import { useController } from '@tokamakjs/react';
import { useEffect } from 'react';

import { createTranslate } from '~/utils';

import checkEmails from '../../assets/check-email.svg';
import { ConfirmationController } from './confirmation.controller';

const styles = {
  buttonsSize: css`
    width: 100%;
  `,
  confirmationSidebar: css`
    text-align: center;
  `,
};

const tt = createTranslate('routes.confirmation');

const AskForConfirmation = (props: { controller: ConfirmationController }) => {
  return (
    <Flex direction={FlexDirection.VERTICAL} align={FlexAlign.CENTER}>
      <FlexItem>
        <img width="240px" src={checkEmails} />
      </FlexItem>
      <FlexItem>
        <Title>{tt('check_emails')}</Title>
      </FlexItem>
      <FlexSpacer size={Size.SMALL} />
      <FlexItem>
        <Text>{tt('almost_done')}</Text>
      </FlexItem>
      <FlexSpacer size={Size.EXTRA_SMALL} />
      <FlexItem>
        <Text>{tt('check_emails_long')}</Text>
      </FlexItem>
      <FlexSpacer size={Size.HUGE} />
      <FlexItem>
        <div className={styles.buttonsSize}>
          <Button
            className={styles.buttonsSize}
            onClick={(e) => {
              e.preventDefault();

              props.controller.checkIfUserIsAlreadyConfirmed();
            }}
            trailing={
              props.controller.checkingIfUserIsAlreadyConfirmed ? (
                <Spinner size={Size.SMALL} />
              ) : null
            }
            disabled={props.controller.checkingIfUserIsAlreadyConfirmed}
            size={Size.LARGE}
            tier={Tier.SECONDARY}>
            {tt('already_confirmed')}
          </Button>
        </div>
      </FlexItem>
    </Flex>
  );
};

const RunConfirmation = (props: { controller: ConfirmationController }) => {
  useEffect(() => {
    props.controller.confirmUser();
  }, []);

  return (
    <div className={styles.confirmationSidebar}>
      <img src={checkEmails} />
      <Title>{tt('confirming')}</Title>
      <Margin size={{ top: Size.SMALL }}>
        {props.controller.confirmationErrorOccurred ? null : (
          <ListTile
            trailing={<Spinner color={Color.BLUE} />}
            title={<Text>{tt('will_redirect')}</Text>}
          />
        )}
      </Margin>
    </div>
  );
};

export const ConfirmationView = () => {
  const controller = useController<ConfirmationController>();

  if (controller.userIsLoading) {
    return null;
  } else if (controller.token && controller.userIsConfirmed === false) {
    return <RunConfirmation controller={controller} />;
  } else {
    return <AskForConfirmation controller={controller} />;
  }
};
